import React, {useState} from "react";
import {Box, Container, List, ListItem, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {API_BASE_URL} from "./SignUp";

const FindId: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    const [phone, setPhone] = useState('');
    const [accountIds, setAccountIds] = useState<{ accountId: string }[]>([]); // 상태로 accountId 배열 관리

    const navigate = useNavigate()

    const handleFindId = async () => {
        try {
            const response = await axios.post(`${API_BASE_URL}/find-id/${phone}`);
            setAccountIds(response.data); // 응답 데이터를 상태로 저장 (accountId 배열)
        } catch (error) {
            console.error("Failed to find account IDs", error);
        }
    };

    const handleCancelFindId = () => {
        onClose()
    };

    return (
        <>
            <Container maxWidth="xs" style={{ marginTop: '50px' }}>
                <Typography variant="h5" align="center" gutterBottom>
                    아이디 찾기
                </Typography>
                <TextField
                    label="전화번호"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleFindId}
                    sx={{ mt: 2 }}
                    style={{
                        marginBottom: '10px'
                    }}
                >
                    아이디 찾기
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    onClick={handleCancelFindId}
                    style={{
                        marginBottom: '2rem'
                    }}
                >
                    닫기
                </Button>


                {/* 로그인 하기 버튼 아래에 아이디 리스트 표시 */}
                {accountIds.length > 0 && (
                    <>
                        <Typography variant="h6" align="center" gutterBottom sx={{ mt: 2 }}>
                            찾은 아이디 목록:
                        </Typography>
                        <List
                            style={{
                                marginBottom: '2rem'
                            }}
                        >
                            {accountIds.map((account, index) => (
                                <ListItem key={index}>
                                    {account.accountId}
                                </ListItem>
                            ))}
                        </List>
                    </>
                )}
            </Container>
        </>
    );
}

export default FindId